const mediaItems = [
  {
    title: '《流浪地球3》终极预告',
    desc: '人类文明面临终极考验，太阳危机迫在眉睫，全球影迷翘首以盼的科幻巨制。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20massive%20planetary%20engines%2C%20Earth%20from%20orbit%2C%20dramatic%20cosmic%20lighting%2C%20orange%20and%20blue%20contrast%2C%20cinematic%20composition%2C%20grand%20scale%2C%20atmospheric%20space%20photography&width=900&height=506&seq=media-wandering-97&orientation=landscape',
    duration: '02:35',
  },
  {
    title: '《封神第二部》幕后特辑',
    desc: '独家探秘封神剧组拍摄现场，看神话史诗如何从文字走向银幕。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battlefield%20scene%2C%20epic%20warriors%20in%20armor%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20cinematic%20scale%2C%20mist%20and%20fire%2C%20historical%20fantasy%20aesthetic%2C%20high%20detail&width=900&height=506&seq=media-fengshen-97&orientation=landscape',
    duration: '05:18',
  },
  {
    title: '年度高分电影混剪',
    desc: '回顾过去一年最令人难忘的电影瞬间，每一帧都是经典。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20montage%20collage%2C%20dramatic%20movie%20scenes%20blended%20artistically%2C%20warm%20golden%20and%20deep%20shadow%20tones%2C%20film%20grain%20texture%2C%20artistic%20double%20exposure%2C%20emotional%20cinematography&width=900&height=506&seq=media-montage-97&orientation=landscape',
    duration: '08:42',
  },
  {
    title: '《奥本海默》深度解析',
    desc: '诺兰最新力作全方位解读，原子弹诞生背后的历史与人性博弈。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20cinematic%20portrait%20style%2C%20intense%20scientific%20laboratory%20atmosphere%2C%20mushroom%20cloud%20silhouette%2C%20high%20contrast%20lighting%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%2C%20historical%20drama%20mood&width=900&height=506&seq=media-oppenheimer-97&orientation=landscape',
    duration: '12:10',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          最新预告、幕后花絮、深度解析，精彩不停
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article key={item.title} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute bottom-3 right-3 text-xs text-white bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded">
                  {item.duration}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}